{
  "type": "NeuralNetwork",
  "sizes": [5, 3, 1],
  "layers": [{
    "weights": [],
    "biases": []
  }, {
    "weights": [
      [-25.43618392944336, -3.4433767795562744, -0.03385753929615021, 8.374555587768555, -3.4410276412963867],
      [-44.51546096801758, -0.39139410853385925, -0.16014152765274048, -19.919836044311523, -9.48188591003418],
      [14.085132598876953, 4.423830032348633, -0.14596684277057648, -18.005434036254883, -36.30036926269531]
    ],
    "biases": [22.236295700073242, 36.605403900146484, 13.095133781433105]
  }, {
    "weights": [
      [1.1245135068893433, 2.4052913188934326, 0.6236976981163025]
    ],
    "biases": [-0.024084031581878662]
  }],
  "inputLookup": {
    "temp": 0,
    "cloudcover": 1,
    "precip": 2,
    "wspd": 3,
    "humidity": 4
  },
  "inputLookupLength": 5,
  "outputLookup": {
    "generatedkW": 0
  },
  "outputLookupLength": 1,
  "options": {
    "inputSize": 0,
    "outputSize": 0,
    "binaryThresh": 0.5
  },
  "trainOpts": {
    "activation": "sigmoid",
    "iterations": 80000,
    "errorThresh": 0.005,
    "log": false,
    "logPeriod": 10,
    "leakyReluAlpha": 0.01,
    "learningRate": 0.3,
    "momentum": 0.1,
    "callbackPeriod": 10,
    "timeout": "Infinity",
    "beta1": 0.9,
    "beta2": 0.999,
    "epsilon": 1e-8
  }
}
